import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType } from 'components/list/DynamicListFilterUtils';

import { REASONCONFIG } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

/**
 * @author @omerrkosar
 */

const ReasonConfigList = () => {
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'reasonType',
				accessor: 'reasonType',
				width: 100,
				filterType: FilterType.multiSelection,
				showOnMobile: true
			},
			{ Header: 'reasonEnglish', accessor: 'reasonEng', width: 130, filterType: FilterType.string },
			{ Header: 'reasonArabic', accessor: 'reasonAr', width: 100, filterType: FilterType.string },
			{ Header: 'reasonTurkish', accessor: 'reasonTr', width: 100, filterType: FilterType.string }
		],
		[]
	);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.REASON_CONFIG_LIST}
				columns={columns}
				fetchUrl={REASONCONFIG.GET_REASON_CONFIG_LIST}
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
				exportName="reasonConfig"
				defaultSort={defaultSort}
			/>
		</TabTableContainer>
	);
};

export default ReasonConfigList;
